// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';

// --- 3rd Party
import { TranslateService } from '@ngx-translate/core';

// --- HS Code
import { ApplicationError, GroupModel, RespondentModel } from '../../../models';
import { AppService } from '../app.service';
import { OidcService } from '../account/oidc.service';
import { ParticipantGroupsBaseService } from './participant-groups-base.service';
import { SurveyBaseService } from './survey-base.service';
import { UserNotificationBaseService } from '../notifications/user-notification-base.service';

// #endregion

@Injectable({
  providedIn: 'root',
})
export class ParticipantGroupsMockService extends ParticipantGroupsBaseService {
  override saveGroupChanges(deletedGroups: GroupModel[], addedGroups: GroupModel[], updatedGroups: GroupModel[], managedGroups: GroupModel[], participantId: string): void {
    throw new Error('Method not implemented.');
  }

  constructor(
    private surveyService: SurveyBaseService,
    appService: AppService,
    translateService: TranslateService,
    oidcService: OidcService,
    userNotificationService: UserNotificationBaseService
  ) {
    super(translateService, oidcService, appService, userNotificationService);
  }

  loadGroups(identifier: string, isSilent: boolean = false): void {
    if (identifier === 'HSC210315') {
      const surveyId = this.surveyService.getSurveyId(identifier);
      of([this.createGroup(surveyId)] as GroupModel[])
        .pipe(delay(3000))
        .subscribe((result) => {
          this._participantGroups$.next(result);
        });
    }
  }

  add(group: GroupModel): void {
    let groups = this._participantGroups$.value;
    if (groups === null) {
      groups = [] as GroupModel[];
    }
    if (group.groupName) {
      const exists = groups.find(
        (g) =>
          g.groupName.toLowerCase() === group.groupName.toLowerCase() &&
          g.id !== group.id
      );
      if (exists) {
        this.appService.setLastError({
          errorMessage: this.translateService.instant(
            'inviteRespondentsErrorDuplicateGroupName'
          ),
        } as ApplicationError);
        group.groupName = '';
        return;
      }
      group.isSet = true;
    }
    const foundGroup = groups.find((g) => {
      return g.id === group.id;
    });
    if (foundGroup) {
      foundGroup.isSet = group.isSet;
      foundGroup.groupName = group.groupName;
      foundGroup.participantId = group.participantId;
    } else {
      groups.push(group);
    }
    this._participantGroups$.next(groups.splice(0));
  }

  saveGroup(group: GroupModel): void {
    const groups = this._participantGroups$.value;
    if (!groups) {
      return;
    }
    const updateGroup = groups.find((g) => {
      return g.id === group.id;
    });
    if (updateGroup) {
      updateGroup.groupName = group.groupName;
      this._participantGroups$.next(groups.splice(0));
    }
  }

  update(groups: GroupModel[]): void {}

  updateGroupName(group: GroupModel): void {
    const groups = this._participantGroups$.value;
    if (!groups) {
      return;
    }
    const updateGroup = groups.find((g) => {
      return g.id === group.id;
    });
    if (updateGroup) {
      updateGroup.groupName = group.groupName;
      this._participantGroups$.next(groups.splice(0));
    }
  }

  delete(group: GroupModel): void {
    const groups = this._participantGroups$.value;
    if (!groups || group.index === 1) {
      return;
    }
    let index = group.index;
    const groupIndex = groups.findIndex((g) => {
      return g.id === group.id;
    });
    if (groupIndex < 0) {
      return;
    }
    groups.splice(groupIndex, 1);
    groups.forEach((g) => {
      if (g.index >= group.index) {
        g.index = index++;
      }
    });
    this._participantGroups$.next(groups.splice(0));
  }
}
